import { render, staticRenderFns } from "./SortingArrows.vue?vue&type=template&id=11f265bc&scoped=true&"
import script from "./SortingArrows.vue?vue&type=script&lang=js&"
export * from "./SortingArrows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f265bc",
  null
  
)

export default component.exports